import { Abbr } from "@site/src/components";

export default function ThirdPersonSingularFeminine() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td> ja [ona]</td>
          <td>jǫ </td>
          <td>jeję </td>
          <td>jeji </td>
          <td>jejǫ</td>
          <td>jeji</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td> oná </td>
          <td>jejo </td>
          <td>jejo </td>
          <td>jej </td>
          <td>jej </td>
          <td>nej</td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td> janá</td>
          <td>jaé </td>
          <td>jaé </td>
          <td>ëj </td>
          <td>ëj/ëju</td>
          <td>ëj</td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td> voná</td>
          <td>jijí </td>
          <td>jijí </td>
          <td>jij </td>
          <td>néju</td>
          <td>nij</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td> ona </td>
          <td>jej/ju </td>
          <td>jej </td>
          <td>ij </td>
          <td>njom</td>
          <td>nij/nej</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td> ona </td>
          <td>ją </td>
          <td>jej </td>
          <td>jej </td>
          <td>nią </td>
          <td>niej</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td> ona/na</td>
          <td>ję </td>
          <td>ji/jé</td>
          <td>ji </td>
          <td>nią </td>
          <td>ni</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td> wona</td>
          <td>ju </td>
          <td>jeje </td>
          <td>jej </td>
          <td>njeju </td>
          <td>njej</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td> wona</td>
          <td>ju </td>
          <td>jeje </td>
          <td>jej/ji</td>
          <td>njej</td>
          <td>njej</td>
        </tr>
        <tr>
          <th>Czech</th>
          <td> ona </td>
          <td>ji </td>
          <td>jí </td>
          <td>jí </td>
          <td>jí </td>
          <td>ní</td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td> ona </td>
          <td>ju </td>
          <td>jej </td>
          <td>jej </td>
          <td>ňou </td>
          <td>nej</td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td> ona </td>
          <td>njo </td>
          <td>nje </td>
          <td>njej/nji</td>
          <td>njo </td>
          <td>njej/nji</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td> òna </td>
          <td>njû/je/ju</td>
          <td>njê/je </td>
          <td>njôj/jôj</td>
          <td>njôm</td>
          <td>njôj</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td> taa </td>
          <td>nea/ja </td>
          <td>—</td>
          <td>nejze/i </td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td> tja </td>
          <td>néja/ja</td>
          <td>—</td>
          <td>i/nej </td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>ona</b>
          </td>
          <td>
            <b>(n)jų</b>
          </td>
          <td>
            <b>(n)jej</b>
          </td>
          <td>
            <b>(n)jej</b>
          </td>
          <td>
            <b>(n)jejų</b>
          </td>
          <td>
            <b>(n)jej</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
